import React, { FC } from "react";
import { useTranslation, Trans } from "i18n";
import { TagminLogo } from "assets";

const NoTagminAgentBanner: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-1.5 p-2.5 bg-tagmin-bg border border-t-[5px] border-tagmin-primary rounded">
      <div>
        <p className="font-semibold">
          {t("common:selfTapes.request.sendToClient.noTagminAgentBanner.title")}
        </p>
        <p>
          <Trans
            i18nKey="common:selfTapes.request.sendToClient.noTagminAgentBanner.text"
            components={{
              a: <a href="https://www.tagmin.co.uk/" target="_blank" />,
            }}
          />
        </p>
      </div>
      <div>
        <TagminLogo height={40} />
      </div>
    </div>
  );
};

export default NoTagminAgentBanner;
